//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import unity from "@/unity/unity";
import moment from "moment";

const ALL_DEPARTMENTS = "All departments";
const ALL_TYPES = "All leave types";
const ALL_STATUSES = "All statuses";

const AVATAR_COLORS = [
  { bg: "#E6F2F8", fg: "#2A6F97" },
  { bg: "#ECE9FB", fg: "#4B3BA8" },
  { bg: "#FDF1E3", fg: "#8A4B0F" },
  { bg: "#E6F6EE", fg: "#1E7A4C" },
  { bg: "#FDE8EA", fg: "#B4232F" },
  { bg: "#E8F4FA", fg: "#1D6A8A" },
  { bg: "#FBE7DF", fg: "#A2401C" },
];

export default {
  name: "leave-list",
  data(vm) {
    return {
      authorize: [],
      search: "",
      menu: false,
      menu2: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Submit"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],

      page: 1, // หน้าเริ่มต้น
      itemsPerPage: 20, // จำนวนรายการต่อหน้า
      rowsPerPageOptions: [10, 20, 50, 100],
      leavehistory_list: [],
      datashowAll: [],
      // ===== ตัวกรองใหม่ =====
      filterDepartment: ALL_DEPARTMENTS,
      filterType: ALL_TYPES,
      filterStatus: ALL_STATUSES,
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.datashowAll.length / this.itemsPerPage)); // คำนวณจำนวนหน้าทั้งหมด
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.datashowAll.slice(start, end); // ดึงรายการที่ต้องแสดงในแต่ละหน้า
    },

    // ===== UI ใหม่ =====
    approvedCount() {
      return this.leavehistory_list.filter((i) => i.status_name == "Approved").length;
    },
    rejectedCount() {
      return this.leavehistory_list.filter((i) => i.status_name == "Rejected").length;
    },
    statusOptions() {
      const st = [...new Set(this.leavehistory_list.map((i) => this.statusText(i)))].sort();
      return [ALL_STATUSES, ...st];
    },
    departmentOptions() {
      const deps = [
        ...new Set(this.leavehistory_list.map((i) => this.departmentName(i)).filter(Boolean)),
      ].sort();
      return [ALL_DEPARTMENTS, ...deps];
    },
    leaveTypeOptions() {
      const types = [...new Set(this.leavehistory_list.map((i) => i.leave_type).filter(Boolean))].sort();
      return [ALL_TYPES, ...types];
    },
    showingFrom() {
      return this.datashowAll.length === 0 ? 0 : (this.page - 1) * this.itemsPerPage + 1;
    },
    showingTo() {
      return Math.min(this.page * this.itemsPerPage, this.datashowAll.length);
    },
    pageButtons() {
      const total = this.pageCount;
      const cur = this.page;
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
      const pages = [1];
      const start = Math.max(2, cur - 1);
      const end = Math.min(total - 1, cur + 1);
      if (start > 2) pages.push("...");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < total - 1) pages.push("...");
      pages.push(total);
      return pages;
    },
  },
  watch: {
    itemsPerPage() {
      this.page = 1;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    // const router_path = parser.pathname.replace("/", "");

    // const res_auth = await api.getAuthorize(this.userId, router_path);

    // // console.log("res_auth:" + JSON.stringify(res_auth.data));

    // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    //    if (!this.authorize_view) {
    //   this.$router.push("/not-found");
    // }

    // // ----------------- Check Authorize ---------------------------

    // let comp_id = localStorage.getItem(server.COMPANYID);

    // this.userId = localStorage.getItem(server.USER_ID);
    // if (this.userId && api.isLoggedIn()) {
    //   // this.$router.push("/");
    // } else {
    //   this.$store.state.isLogged = false;
    //   this.$router.push("/login");
    // }

    await this.loaddataLeaveRequest(this.userId);
    await this.loadleaveHistory(this.userId);
    this.$hideLoader();
  },
  methods: {
    async getBackList() {
      this.$router.push(`/approver-time-off`);
    },
    openApporverHistory() {
      this.$router.push("/approver-history");
    },
    async loadleaveHistory() {
      const res_leave_history = await api.getListApproveAllHistory(
        localStorage.getItem(server.USER_ID)
      );

      for (const [index, item] of res_leave_history.data.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else {
            item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            item.description = `${item.data_date} (${leave_day} day)`;
          } else {
            item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }

        if (item.image != "" && item.image != null) {
          item.image_profile = imageUrl + "/" + item.image;
        } else {
          item.image_profile = "";
        }
      }
      this.leavehistory_list = res_leave_history.data;
      this.datashowAll = res_leave_history.data;
    },
    async goToLeaveApproveById(id, user_id) {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push(`/leave-request-waiting/${id}/approverhistory`); // หากคุณใช้ Vue Router
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    // ค้นหา (เงื่อนไขเดิม: ชื่อ/ประเภทลา + ช่วงวันที่) + เพิ่มกรองแผนก/ประเภทลา
    async search_data() {
      const searchTerm = String(this.search || "").toLowerCase();
      const text = (v) => String(v || "").toLowerCase();

      this.datashowAll = this.leavehistory_list.filter((item) => {
        const matchSearch =
          text(item.name_eng).includes(searchTerm) ||
          text(item.name_th).includes(searchTerm) ||
          text(item.leave_type).includes(searchTerm);

        const matchDate =
          this.datefrom && this.dateto
            ? this.datefrom <= item.str_time && this.dateto >= item.end_time
            : true;

        const matchDep =
          this.filterDepartment === ALL_DEPARTMENTS || this.departmentName(item) === this.filterDepartment;

        const matchType = this.filterType === ALL_TYPES || item.leave_type === this.filterType;

        const matchStatus = this.filterStatus === ALL_STATUSES || this.statusText(item) === this.filterStatus;

        return matchSearch && matchDate && matchDep && matchType && matchStatus;
      });
      this.page = 1;
    },
    resetFilters() {
      this.search = "";
      this.datefrom = null;
      this.dateto = null;
      this.filterDepartment = ALL_DEPARTMENTS;
      this.filterType = ALL_TYPES;
      this.filterStatus = ALL_STATUSES;
      this.search_data();
    },
    previousPage() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page += 1;
      }
    },

    // ================= UI helpers (ใหม่) =================
    employeeName(item) {
      const en = String(item.name_eng || "").trim();
      const th = String(item.name_th || "").trim();
      return en || th || "-";
    },
    // ชื่อแผนก (รองรับหลายชื่อ field จาก API)
    departmentName(item) {
      return (
        item.department_name || item.dep_name || item.department || item.dept_name || item.departmentname || ""
      );
    },
    getInitials(name) {
      const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
      if (!parts.length || name === "-") return "?";
      return ((parts[0][0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
    },
    // สี avatar คงที่ตามชื่อ (คนเดิมได้สีเดิมทุกครั้ง)
    avatarColor(name) {
      let h = 0;
      const s = String(name || "");
      for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
      return AVATAR_COLORS[h % AVATAR_COLORS.length];
    },
    leaveDateText(item) {
      const start = item.str_time ? moment(item.str_time, "YYYY-MM-DD") : null;
      const end = item.end_time ? moment(item.end_time, "YYYY-MM-DD") : null;
      if (!start || !start.isValid()) return item.data_date || "-";
      if (!end || !end.isValid() || end.isSame(start, "day")) return start.format("D MMM YYYY");
      return `${start.format("D MMM YYYY")} - ${end.format("D MMM YYYY")}`;
    },
    formatDuration(hoursAmount) {
      const total = Number(hoursAmount) || 0;
      if (total <= 0) return "-";
      const d = Math.floor(total / 8);
      const h = Number((total - d * 8).toFixed(2));
      const parts = [];
      if (d > 0) parts.push(`${d} ${d === 1 ? "day" : "days"}`);
      if (h > 0) parts.push(`${h} ${h === 1 ? "hour" : "hours"}`);
      return parts.join(" ");
    },
    // อนุมัติ/ปฏิเสธแล้ว (เงื่อนไขเดียวกับ goToLeaveApproveById: status 3, 4)
    isReviewed(item) {
      const s = String(item.status_name || "").toLowerCase();
      return Number(item.status) == 3 || Number(item.status) == 4 || s === "approved" || s === "rejected";
    },
    statusText(item) {
      if (item.status_name == "Approved" || item.status_name == "Rejected") return item.status_name;
      return "Pending";
    },
    statusChipClass(item) {
      if (item.status_name == "Approved") return "ap-chip-success";
      if (item.status_name == "Rejected") return "ap-chip-danger";
      return "ap-chip-warning";
    },

    async loaddataLeaveRequest(id) {
      // const result = await api.getListApproveByApproverIDbyCompany(id,localStorage.getItem(server.COMPANYID));
      const result = await api.getListApproveIdNow(id);
      this.mDataArray = result.data;

      // console.log("dateAll:")
      //   console.log(this.dataAll)
      //   console.log("loadLeave", JSON.stringify(this.dataAll));

      // image

      this.mDataArray.forEach((item) => {
        var tmp = {
          id: 13,
          employee_id: "163",
          startDate: "2022-06-20T01:30:00.000Z",
          endDate: "2022-06-20T10:30:00.000Z",
          startDate2: "2022-06-20 08:30:00",
          endDate2: "2022-06-20 17:30:00",
          amount: "8.00",
          leaveTypeId: 2,
          leave_type: "ลากิจ",
          description: "test emp",
          description_approve: "test approve emp",
          approve_id: 1,
          approve_name: "Request",
          approver_level1: 80,
          fullName: "นาย Test Employee",
          image: "",
        };
        tmp.id = item.id;
        tmp.employee_id = item.employee_id;
        tmp.startDate = item.startDate;
        tmp.endDate = item.endDate;
        tmp.startDate2 = item.startDate2;
        tmp.endDate2 = item.endDate2;
        tmp.startDateS = item.startDateS;
        tmp.endDateS = item.endDateS;
        tmp.amount = item.amount;
        tmp.amount_show = this.quotaListConvert(item.amount / 8);
        tmp.leaveTypeId = item.leave_type_id;
        tmp.leave_type = item.leave_type;
        tmp.description = item.description;
        tmp.description_approve = item.description_approve;
        tmp.approve_id = item.approve_id;
        tmp.approve_name = item.approve_name;
        tmp.approver_level1 = item.approver_level1;
        tmp.fullName = item.fullName;
        // tmp.image = item.image;

        if (item.image == "" || item.image == null) {
          tmp.image = imageUrl + "/personal.png";
        } else {
          tmp.image = imageUrl + "/" + item.image;
        }

        this.dataAll.push(tmp);
      });

      console.log(this.dataAll);

      // this.dataAll = result.data;
      // this.mDataArray = result.data;

      // this.$showLoader();
    },
    quotaListConvert: function (H) {
      var d = 0;
      var h = 0;
      var m = 0;
      var tmp1 = parseFloat(H * 480);
      var tmp_final;

      var tmp_d = tmp1 / 480;

      d = Math.floor(tmp_d);
      h = Math.floor((tmp_d - d) * 8);
      m = Math.floor(((tmp_d - d) * 8 - h) * 60);

      tmp_final = `${d} Days ${h} Hour ${m} Minute`;

      return tmp_final;
    },
  },
};
